import React, {useEffect, useState} from "react";
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Fade from '@mui/material/Fade';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Divider } from "@mui/material";
import { useSelector } from 'react-redux';


const Question = ({question, answer, screenSize=3, selectedQuestion, setSelectedQuestion}) => {
    const {deviceType, resolution} = useSelector(state => state.configuration);
    const [expanded, setExpanded] = useState(false);
    
    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : '');
        setSelectedQuestion(isExpanded ? question : 'none')
    };

    useEffect(()=>{
        setExpanded(selectedQuestion===question ? 'panel1' : '')
    }, [selectedQuestion]);

        
    return(
        <>
            <Accordion
                expanded={expanded === 'panel1'}
                onChange={handleChange('panel1')}
                slots={{ transition: Fade }}
                slotProps={{ transition: { timeout: 500 } }}
                sx={{
                    backgroundColor:'transparent',
                    boxShadow:'none',
                    color:'white',
                    marginBottom: '30px',
                    '&::before': {
                        display: 'none',
                    },
                }}
            >
                <AccordionSummary 
                    expandIcon={<ExpandMoreIcon sx={{color:'white', fontSize:'extra-large'}} />}
                    aria-controls="panel1-content"
                    id="panel1-header"
                    className="text-subtitle"
                    sx={{
                        flexDirection: 'row-reverse',
                        fontWeight: 'bold',
                        // color: selectedQuestion===question ? '#CBE3FF' : 'white',0076ff
                        color: selectedQuestion===question ? '#4696f2' : 'white',
                        WebkitTextStroke: selectedQuestion===question ? '.00001px #0102CE' : '',
                        "&:hover": {
                                color: '#4696f2',
                                WebkitTextStroke: '.00001px #0102CE',
                            },
                        // fontSize: '18px',
                        // color: color
                    }}
                >
                    <span style={{marginLeft:screenSize===1 ? '0px' : '30px', marginRight:screenSize===1 ? '0px' : '30px'}} >{question}</span>
                </AccordionSummary>
                <AccordionDetails 
                    sx={{
                        transition: 'all 0.4s ease',
                        color: 'white',
                        fontSize:'18px',
                        display:expanded === 'panel1' ? 'block' : 'none'
                    }}
                >
                    <div style={{marginLeft:screenSize===1 ? '30px' : '60px', marginRight:screenSize===1 ? '3px' : '60px'}} >
                        {answer}
                    </div>
                </AccordionDetails>
            </Accordion>
            <Divider orientation="horizontal" color="#676767" sx={{marginBottom: '30px',}} />
        </>
    );
}

export default Question;